export default __webpack_public_path__ + "static/media/my_journey_part2_1.4bb7adc2.png";